
/* eslint-disable vue/no-reserved-component-names,vue/multi-word-component-names */
import { Content, Title } from './style'
import VueTypes from 'vue-types'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Popover',
  props: {
    placement: VueTypes.string.def('bottom'),
    title: VueTypes.string,
    class: VueTypes.string,
    action: VueTypes.string.def('hover')
  },
  data () {
    return {
      visible: false,
      className: this.class
    }
  },
  components: {
    Content,
    Title
  }
})
